module.exports = __webpack_public_path__ + "static/feather-2-ccd47ff239c752e2868838dda68c4db1.png";